<template>
    <v-container fluid v-if="sessionActive">

        <v-card color="grey darken-3" height="100%" class="pt-0 pl-0">

            <material-header
                    :loading="loading"
                    title="Financial reports"
                    info="Understand recruitment costs, ROI and more"
                    help="financial-reports"
                    icon="mdi-finance">
            </material-header>

            <v-alert v-if="!hasPermission(minPermission)"
                     class="body-2"
                     type="error"
            >
                Your user account doesn't have sufficient permissions for this feature
            </v-alert>

            <v-tabs v-if="hasPermission(minPermission)"
                    v-model="activeTab"
                    dark
                    slider-color="primary"
                    color="white"
                    class="mb-6"
            >

                <v-tab key="tab1" class="ml-3">Dashboard</v-tab>
                <v-tab key="tab2">By recruitment source</v-tab>
                <v-tab key="tab3">By sub panel</v-tab>

                <v-tab-item key="tab1">
                    <dashboard></dashboard>
                </v-tab-item>

                <v-tab-item key="tab2">
                    <recruitment-sources></recruitment-sources>
                </v-tab-item>

                <v-tab-item key="tab3">
                    <sub-panels></sub-panels>
                </v-tab-item>

            </v-tabs>
        </v-card>


    </v-container>
</template>

<script>

    import MaterialHeader from '../../../components/UI/MaterialHeader';
    import Store from '../store';
    import activeSessionChecker from '../../../components/mixins/activeSessionCheckerMixin';
    import ToolbarPage from '../../../components/UI/ToolbarPage';
    import Dashboard from './Dashboard';
    import RecruitmentSources from './RecruitmentSources';
    import SubPanels from './SubPanels';
    import {mapState, mapMutations, mapGetters, mapActions} from 'vuex';

    const vuexModule = 'Financials';

    export default {

        mixins: [activeSessionChecker],

        components: {
            ToolbarPage,
            MaterialHeader,
            Dashboard,
            RecruitmentSources,
            SubPanels
        },

        data() {
            return {
                minPermission: 'view financial reports',
                activeTab: 0

            }
        },

        computed: {
            ...mapState(vuexModule, [
                'loading'
            ])
        },

        created() {
            if (!this.$store.state[vuexModule]) {
                this.$store.registerModule(vuexModule, Store);
            }
        },
    }

</script>
